/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsReplayConnectionDtoSchema } from "./replayConnectionDtoSchema.ts";
import { goodLuckCoreDTOsReplayGlScoreComponentDtoSchema } from "./replayGlScoreComponentDtoSchema.ts";
import { goodLuckCoreDTOsReplayMetricValueDtoSchema } from "./replayMetricValueDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayPlayerMetricsDtoSchema = z.object({
  userId: z.string().nullish(),
  riotIdGameName: z.string().nullish(),
  riotIdTagLine: z.string().nullish(),
  displayName: z.string().nullish(),
  avatarUrl: z.string().nullish(),
  position: z.string().nullish(),
  teamSide: z.string().nullish(),
  win: z.boolean().nullish(),
  gameId: z.int().nullish(),
  champion: z.string().nullish(),
  get connection() {
    return goodLuckCoreDTOsReplayConnectionDtoSchema.optional();
  },
  gamesTotal: z.optional(z.int()),
  gamesExcludedAsShort: z.optional(z.int()),
  gamesExcludedAsDirty: z.optional(z.int()),
  integrityFlags: z.array(z.string()).nullish(),
  get metrics() {
    return z.array(goodLuckCoreDTOsReplayMetricValueDtoSchema).nullish();
  },
  glScore: z.number().nullish(),
  get glScoreComponents() {
    return z.array(goodLuckCoreDTOsReplayGlScoreComponentDtoSchema).nullish();
  },
});
